import { Dialog } from "@dash/dialog";
import { Button } from "@dash/form";
import { LocationPicker } from "@dash/google-map";
import { useDeviceType } from "@dash/mq";

import { CustomerData, ExtendedCustomerAddress } from "./useCustomerDetailsForm";

type Props = {
  onSave: () => void;
  onClose: () => void;
  customer: CustomerData;
  onAddressChange: (newAddress: ExtendedCustomerAddress) => void;
  isLoading?: boolean;
};

export const EditCustomerAddressDialog: React.FC<Props> = ({
  onSave,
  onClose,
  customer,
  onAddressChange,
  isLoading,
}) => {
  const { isMobile } = useDeviceType();

  return (
    <Dialog onClose={onClose} placement={isMobile ? "top" : "center"} header={"Dane klienta"}>
      <div
        css={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "400px",
          margin: "auto",
          gap: "20px",
          width: "100%",
        }}
      >
        <LocationPicker
          customer={customer}
          onAddressChange={(addr) => onAddressChange({ ...customer.address, ...addr })}
        />
        <Button
          onClick={() => {
            onSave();
            onClose();
          }}
          isLoading={isLoading}
          css={{ alignSelf: "flex-end" }}
        >
          Zatwierdź
        </Button>
      </div>
    </Dialog>
  );
};
